'use client'

import { useParams } from 'next/navigation'
import { Image as DatoImage } from 'react-datocms'
import { Button, cn, Heading, RightTopArrow } from '@desoutter/uikit'
import { PagelinksProductsListItemFragment } from './PagelinksProductsListItem.generated'
import { HeroBasicBlockRecord } from '@/graphql/types'
import { LocalizedLink } from '@/components/LocalizedLink'

type PagelinksProductsListItemProps = {
	fragment: PagelinksProductsListItemFragment
}

export default function PagelinksProductsListItem({
	fragment,
}: PagelinksProductsListItemProps) {
	const { lang } = useParams()
	return (
		<LocalizedLink
			locale={lang}
			href={`/products/series/${fragment.slug}`}
			className="cursor-pointer"
			prefetch={false}
		>
			<div
				className={cn(
					'group flex items-center py-6 border-b border-gray-900 dark:border-gray-800 gap-6 w-full',
					'hover:border-gray-500 hover:bg-gradient-to-t from-gray-50 dark:from-gray-500 to-transparent duration-200 hover:scale-[1.02] ease-out',
				)}
			>
				{fragment.image && (
					<DatoImage
						data={fragment.image.responsiveImage}
						objectPosition="left bottom"
						objectFit="cover"
						className="w-16 h-16 rounded-md group-hover:scale-110 duration-500 ease-in-out"
					/>
				)}
				<div className="flex flex-col flex-1">
					<Heading as="h5" className="font-medium">
						{fragment.name}
					</Heading>

					<p>{(fragment.heroBlock[0] as HeroBasicBlockRecord)?.title}</p>
				</div>

				<Button
					size="lg"
					icon={RightTopArrow}
					title="go to product"
					color="link"
					className="group-hover:scale-125 duration-100 ease-out group-hover:rotate-45"
				/>
			</div>
		</LocalizedLink>
	)
}
